/**
 * Slivers horde deck.
 * Source: hordemagic.com (300 cards: 170 tokens / 130 nontoken).
 * Scaled to ~100 cards preserving the ~1.3:1 token:nontoken ratio.
 * All nontoken card names verified against local card DB.
 * Token: "Metallic Sliver" (2c7e0d67) — real Scryfall printing.
 * Note: "Spiteful Sliver" and "Talon Sliver" were omitted to reach target count;
 *   "Horned Sliver", "Shadow Sliver", and "Watcher Sliver" also omitted as 1-ofs to trim.
 */
export const sliversDeck = {
    id: 'slivers',
    name: 'Sliver Hive',
    description: 'A pulsing hive-mind of Slivers adapts and overwhelms through shared abilities.',
    cards: [
        // ── Tokens (57 Metallic Sliver) ─────────────────────────────────────────
        { name: 'Metallic Sliver', quantity: 57, isToken: true, scryfallId: '2c7e0d67-b627-4cf7-8f56-e1f0bd75cd5c' },
        // ── Legendary Slivers (5, 1x each) ──────────────────────────────────────
        { name: 'Sliver Hivelord', quantity: 1, isToken: false },
        { name: 'Sliver Legion', quantity: 1, isToken: false },
        { name: 'Sliver Overlord', quantity: 1, isToken: false },
        { name: 'Sliver Queen', quantity: 1, isToken: false },
        { name: 'The First Sliver', quantity: 1, isToken: false },
        // ── Sliver Creatures (32) ────────────────────────────────────────────────
        { name: 'Battering Sliver', quantity: 1, isToken: false },
        { name: 'Belligerent Sliver', quantity: 1, isToken: false },
        { name: 'Bonesplitter Sliver', quantity: 1, isToken: false },
        { name: 'Brood Sliver', quantity: 1, isToken: false },
        { name: 'Cleaving Sliver', quantity: 2, isToken: false },
        { name: 'Crystalline Sliver', quantity: 1, isToken: false },
        { name: 'Diffusion Sliver', quantity: 1, isToken: false },
        { name: 'Fungus Sliver', quantity: 1, isToken: false },
        { name: 'Fury Sliver', quantity: 1, isToken: false },
        { name: 'Groundshaker Sliver', quantity: 1, isToken: false },
        { name: 'Harmonic Sliver', quantity: 1, isToken: false },
        { name: 'Lancer Sliver', quantity: 1, isToken: false },
        { name: 'Lavabelly Sliver', quantity: 2, isToken: false },
        { name: 'Leeching Sliver', quantity: 1, isToken: false },
        { name: 'Megantic Sliver', quantity: 1, isToken: false },
        { name: 'Metallic Sliver', quantity: 2, isToken: false },
        { name: 'Might Sliver', quantity: 1, isToken: false },
        { name: 'Muscle Sliver', quantity: 1, isToken: false },
        { name: 'Predatory Sliver', quantity: 1, isToken: false },
        { name: 'Pulmonic Sliver', quantity: 1, isToken: false },
        { name: 'Shifting Sliver', quantity: 1, isToken: false },
        { name: 'Sidewinder Sliver', quantity: 1, isToken: false },
        { name: 'Sinew Sliver', quantity: 1, isToken: false },
        { name: 'Spined Sliver', quantity: 1, isToken: false },
        { name: 'Steelform Sliver', quantity: 1, isToken: false },
        { name: 'Striking Sliver', quantity: 1, isToken: false },
        { name: 'Tempered Sliver', quantity: 1, isToken: false },
        { name: 'Two-Headed Sliver', quantity: 1, isToken: false },
        { name: 'Vampiric Sliver', quantity: 1, isToken: false },
        { name: 'Venom Sliver', quantity: 1, isToken: false },
        { name: 'Virulent Sliver', quantity: 1, isToken: false },
        { name: 'Winged Sliver', quantity: 2, isToken: false },
        // ── Spells (6) ──────────────────────────────────────────────────────────
        { name: 'Barter in Blood', quantity: 1, isToken: false },
        { name: 'Crackling Doom', quantity: 1, isToken: false },
        { name: 'Destructive Flow', quantity: 1, isToken: false },
        { name: 'Necrotic Hex', quantity: 1, isToken: false },
        { name: 'Soul Shatter', quantity: 1, isToken: false },
        { name: 'Wave of Vitriol', quantity: 1, isToken: false },
    ],
};
//# sourceMappingURL=slivers.js.map